import { connect } from 'react-redux';
import { filterItemDispatcher } from '../../../../../../redux/search-results/search-results.dispatchers';
import { filterItemSelector } from '../../../../../../redux/search-results/search-results.selectors';
import { FilterItem } from '../../../../../popups/filters-popup/components/filter-item';
export default connect(filterItemSelector, filterItemDispatcher)(FilterItem);